import './brands.scss';
import 'slick-carousel';
export default (() => {
  $('.js-brand-slider').slick({
    rows: 0,
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    swipeToSlide: true,
    variableWidth: true
  });
});